import { render, staticRenderFns } from "./salesmanDeduction.vue?vue&type=template&id=1aff7c4a&scoped=true"
import script from "./salesmanDeduction.vue?vue&type=script&lang=js"
export * from "./salesmanDeduction.vue?vue&type=script&lang=js"
import style0 from "./salesmanDeduction.vue?vue&type=style&index=0&id=1aff7c4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aff7c4a",
  null
  
)

export default component.exports